var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvLogoRgbOReg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595 226.8",
    style: {
      enableBackground: "new 0 0 595 226.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0000;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:3.8637;}\n\t.st2{fill:none;stroke:#000000;stroke-width:1.2;stroke-miterlimit:3.8637;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.7;stroke-miterlimit:3.8637;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:0.5;stroke-miterlimit:3.8637;}\n\t.st5{stroke:#000000;stroke-width:0.5;stroke-miterlimit:3.8637;}\n\t.st6{fill:none;stroke:#000000;stroke-width:0.5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schriftzug_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schriftzug"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7,148.8H33v9.4h21.7v7.9H33v11.6h24.7v7.9H23.9v-44.6h32.8V148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,140.9h8.7v44.6h-9.3l-18.2-31.8h-0.1v31.8h-8.7v-44.6h9.8L91.4,172h0.1V140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1,161.5h18.6v24h-6.2l-0.9-5.6c-2.4,2.7-5.8,6.8-13.9,6.8c-10.7,0-20.5-7.7-20.5-23.4c0-12.2,6.8-23.7,21.8-23.6 c13.7,0,19.1,8.9,19.6,15h-9.3c0-1.7-3.2-7.3-9.8-7.3c-6.6,0-12.8,4.6-12.8,16c0,12.2,6.6,15.3,13,15.3c2,0,8.9-0.8,10.8-9.8 h-10.4V161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.3,148.8h-23.7v9.4h21.7v7.9h-21.7v11.6h24.7v7.9h-33.8v-44.6h32.8V148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.3,177.4h22.2v8.1H196v-44.6h9.3V177.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.4,151.2c0,2.3-1.7,4-4.1,5.5c-2.1-2.3-3.2-4.1-3.2-5.6c0-2.4,1.7-3.6,3.6-3.6 C255.7,147.5,257.4,148.7,257.4,151.2z M268.7,175.8c3-3.9,4.5-7.4,5.1-13.4h-7.7c-0.3,3.4-1.2,5.6-2.3,7.3l-6.3-7.8 c1.8-1.1,7.4-4.3,7.4-10.6c0-7.1-6-10.3-10.9-10.3c-7,0-11.9,4.2-11.9,10.2c0,3.9,2.2,7.2,4,9.3l-0.9,0.6 c-7.4,4.5-8.6,8.7-8.6,13c0,6.6,5.4,12.7,13.9,12.7c6.7,0,10.1-2.4,12.7-5l3,3.8h10.5L268.7,175.8z M258.8,176.3 c-1.5,1.4-4,3.1-6.9,3.1c-5.2,0-6.6-4.2-6.6-5.9c0-3.5,1.6-4.8,5.3-7.5L258.8,176.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.9,140.9h9.7l-15.2,44.6h-8.9l-15-44.6h10l9.6,33.8h0.1L308.9,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.8,163.2c0-12.5,7.1-15.6,12.1-15.6c5,0,12.1,3.1,12.1,15.6c0,12.5-7.1,15.6-12.1,15.6 C336.9,178.8,329.8,175.7,329.8,163.2z M320.5,163.2c0,20.9,15.5,23.5,21.4,23.5c5.9,0,21.4-2.5,21.4-23.5 c0-20.9-15.5-23.5-21.4-23.5C336,139.7,320.5,142.3,320.5,163.2z M339.8,128.7H332v7.1h7.8V128.7z M351.9,128.7h-7.8v7.1h7.8 V128.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.1,177.4h22.2v8.1h-31.5v-44.6h9.3V177.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.2,185.5h-9.3v-44.6h9.3v18.1l17-18.1h12l-18.2,18.3l19.3,26.3h-12L421.6,166l-4.3,4.5V185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.4,148.8h-23.7v9.4h21.7v7.9h-21.7v11.6h24.7v7.9h-33.8v-44.6h32.8V148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.8,160.5v-11.9h11.6c5.5,0,6.5,3.5,6.5,5.8c0,4.4-2.4,6.1-7.2,6.1H501.8z M492.6,185.5h9.1v-17.5h9.6 c6.9,0,7.3,2.4,7.3,8.4c0,4.6,0.4,6.9,1,9H530v-1.2c-2-0.7-2-2.4-2-8.9c0-8.3-2-9.7-5.7-11.3c4.4-1.5,6.9-5.7,6.9-10.6 c0-3.9-2.2-12.6-14-12.6h-22.5V185.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.7,171.8c0.1,2.5,1.3,7.2,9.4,7.2c4.4,0,9.3-1.1,9.3-5.8c0-3.5-3.4-4.4-8.1-5.5l-4.8-1.1c-7.2-1.7-14.2-3.3-14.2-13.1 c0-5,2.7-13.7,17.1-13.7c13.7,0,17.3,8.9,17.4,14.4H561c-0.2-2-1-6.7-9.1-6.7c-3.5,0-7.8,1.3-7.8,5.3c0,3.5,2.9,4.2,4.7,4.7 l10.9,2.7c6.1,1.5,11.7,4,11.7,12c0,13.4-13.7,14.6-17.6,14.6c-16.3,0-19.1-9.4-19.1-14.9H543.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Haus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Haus_1_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 217.8,
    y1: 69.1,
    x2: 376.9,
    y2: 69.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260,66.1h75.4c0,0-0.3,3-2.6,3c-2.4,0-67.4,0-69.8,0C260.1,69.1,260,66.1,260,66.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 376.9,
    y1: 101.8,
    x2: 217.8,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dicke_Aussenw\\xE4nde"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 217.8,
    y1: 102,
    x2: 217.8,
    y2: 69.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "338,106.9 378.8,106.9 378.8,101.4 376.9,101.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "217.8,101.4 216.1,101.4 216.1,106.9 257.3,106.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 376.9,
    y1: 102,
    x2: 376.9,
    y2: 69.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M379.8,64.8c-0.6,1.7-2.7,4.1-3.1,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.3,64.7c0.4,1.4,2.3,4.3,2.7,4.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Treppe"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "259.5,105.4 259.5,103.4 335.8,103.4 335.8,105.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "257.3,107.5 257.3,105.4 338,105.4 338,107.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 257.3,
    y1: 107.2,
    x2: 338,
    y2: 107.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "S\\xE4ulen"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 285.4,
    y1: 69.1,
    x2: 285.4,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 288.5,
    y1: 69.4,
    x2: 288.5,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 306.8,
    y1: 69.1,
    x2: 306.8,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 309.9,
    y1: 69.1,
    x2: 309.9,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.9,69.3l-3.3,0c0,0,0,0.4,0.2,0.7c0.3,0.4,1.2,1,1.2,1l1.7,0v0h0.1h0.1v0l1.7,0c0,0,0.9-0.6,1.2-1 c0.3-0.4,0.2-0.7,0.2-0.7L286.9,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M308.3,69.3l-3.3,0c0,0,0,0.4,0.2,0.7c0.3,0.4,1.2,1,1.2,1l1.7,0v0h0.1h0.1v0l1.7,0c0,0,0.9-0.6,1.2-1 c0.3-0.4,0.2-0.7,0.2-0.7L308.3,69.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "305.2,100.3 311.3,100.3 311.3,101.5 305.2,101.5 305.2,100.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.9,
    y: 100.3,
    className: "st5",
    width: 6.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 262.9,
    y1: 69.1,
    x2: 262.9,
    y2: 103.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 267.4,
    y1: 69.1,
    x2: 267.4,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 327.9,
    y1: 69.1,
    x2: 327.9,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 332.5,
    y1: 69.1,
    x2: 332.5,
    y2: 103.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Schornstein"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321.7,
    y: 39.7,
    className: "st1",
    width: 4.6,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.9,
    y: 39.7,
    transform: "matrix(1 -1.425187e-03 1.425187e-03 1 -5.929608e-02 0.3865)",
    className: "st1",
    width: 4.6,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fenster_x5F_linke_T\\xFCr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.8,79c0.1-2,1.6-3.5,3.6-3.6c1.8,0.1,3.4,1.6,3.4,3.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 276.3,
    y1: 79,
    x2: 276.3,
    y2: 72.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 280.8,
    y1: 74.8,
    x2: 278.9,
    y2: 76.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 272.1,
    y1: 74.6,
    x2: 273.9,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.9,79c0-4.2-3.4-7.6-7.7-7.6c-4,0.1-7.3,3.5-7.4,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M276.3,72.8c-3.3,0.1-5.9,2.9-6,6.2h12.2C282.5,75.6,279.7,72.8,276.3,72.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "270.3,80.7 275.6,80.7 275.6,96.1 270.3,96.1 270.3,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 270.3,
    y1: 88.4,
    x2: 275.6,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 270.3,
    y1: 84.6,
    x2: 275.6,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 270.3,
    y1: 91.8,
    x2: 275.6,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 272.9,
    y1: 80.7,
    x2: 272.9,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "277.2,80.7 282.5,80.7 282.5,96.1 277.2,96.1 277.2,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.2,
    y1: 88.4,
    x2: 282.5,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.2,
    y1: 84.6,
    x2: 282.5,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 277.2,
    y1: 91.8,
    x2: 282.5,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 279.9,
    y1: 80.7,
    x2: 279.9,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 268.9,
    y1: 101.8,
    x2: 268.9,
    y2: 78.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.9,
    y1: 101.8,
    x2: 283.9,
    y2: 79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fenster_x5F_rechte_T\\xFCr"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.4,79c0.1-2,1.6-3.5,3.6-3.6c1.8,0.1,3.4,1.6,3.4,3.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 318.9,
    y1: 79,
    x2: 318.9,
    y2: 72.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 323.3,
    y1: 74.8,
    x2: 321.4,
    y2: 76.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 314.6,
    y1: 74.6,
    x2: 316.5,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M326.4,79c0-4.2-3.4-7.6-7.7-7.6c-4,0.1-7.3,3.5-7.4,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.8,72.8c-3.3,0.1-5.9,2.9-6,6.2H325C325,75.6,322.2,72.8,318.8,72.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "312.8,80.7 318,80.7 318,96.1 312.8,96.1 312.8,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 312.8,
    y1: 88.4,
    x2: 318,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 312.8,
    y1: 84.6,
    x2: 318,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 312.8,
    y1: 91.8,
    x2: 318,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 315.4,
    y1: 80.7,
    x2: 315.4,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "319.7,80.7 325,80.7 325,96.1 319.7,96.1 319.7,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.7,
    y1: 88.4,
    x2: 325,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.7,
    y1: 84.6,
    x2: 325,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 319.7,
    y1: 91.8,
    x2: 325,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 322.4,
    y1: 80.7,
    x2: 322.4,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 311.3,
    y1: 101.8,
    x2: 311.3,
    y2: 78.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 326.4,
    y1: 101.8,
    x2: 326.4,
    y2: 79
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fenster_x5F_rechte_Wand"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 342.1,
    y1: 97.7,
    x2: 356.3,
    y2: 97.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.3,79.9c0.4-0.2,1.1-0.1,1.2-0.5c0.1-0.4,0-2.6,0-3.4c0-0.7,0.3-1.1,0.6-1.4c0.2-0.3,1.3-1,1.3-1H339 c0,0,1.1,1,1.3,1.2c0.2,0.2,0.6,0.6,0.7,1.2c0,0.6,0,2.9,0,3.4c0,0.5,0.8,0.3,1.2,0.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "342.1,101.8 342.1,75.6 356.3,75.6 356.3,101.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 348.3,
    y1: 86.9,
    x2: 343.8,
    y2: 86.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 348.3,
    y1: 91.4,
    x2: 343.8,
    y2: 91.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 348.3,
    y1: 82.3,
    x2: 343.8,
    y2: 82.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 354.6,
    y1: 86.9,
    x2: 350.3,
    y2: 86.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 354.6,
    y1: 91.4,
    x2: 350.3,
    y2: 91.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 354.6,
    y1: 82.3,
    x2: 350.3,
    y2: 82.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "343.8,77.6 348.3,77.6 348.3,96.1 343.8,96.1 343.8,77.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "350.3,77.6 354.6,77.6 354.6,96.1 350.3,96.1 350.3,77.6  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fenster_x5F_linke_Wand"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 238.2,
    y1: 97.8,
    x2: 252.3,
    y2: 97.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.3,80c0.4-0.2,1.1-0.1,1.2-0.5c0.1-0.4,0-2.6,0-3.4c0-0.7,0.4-1.1,0.6-1.4c0.2-0.3,1.3-1,1.3-1 s-20.3,0-20.4,0c0.1,0.1,1.1,1,1.3,1.2c0.2,0.2,0.6,0.6,0.7,1.2c0,0.6,0,2.9,0,3.4c0,0.5,0.8,0.3,1.2,0.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "238.2,101.8 238.2,75.7 252.3,75.7 252.3,101.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 244.4,
    y1: 87,
    x2: 239.9,
    y2: 87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 244.4,
    y1: 91.5,
    x2: 239.9,
    y2: 91.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 244.4,
    y1: 82.4,
    x2: 239.9,
    y2: 82.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 250.6,
    y1: 87,
    x2: 246.1,
    y2: 87
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 250.6,
    y1: 91.5,
    x2: 246.1,
    y2: 91.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 250.6,
    y1: 82.4,
    x2: 246.1,
    y2: 82.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "239.8,77.8 244.4,77.8 244.4,96.3 239.8,96.3 239.8,77.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "246.1,77.8 250.6,77.8 250.6,96.3 246.1,96.3 246.1,77.8  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "T\\xFCr"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.2,79c0.1-2,1.6-3.5,3.6-3.6c1.8,0.1,3.4,1.6,3.4,3.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 297.6,
    y1: 79,
    x2: 297.6,
    y2: 72.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 302,
    y1: 74.7,
    x2: 300.1,
    y2: 76.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 293.3,
    y1: 74.7,
    x2: 295.2,
    y2: 76.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.5,72.8c-3.3,0.1-5.9,2.9-6,6.2h12.2C303.7,75.6,301,72.8,297.5,72.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.2,79c0-4.2-3.4-7.6-7.7-7.6c-4,0.1-7.3,3.5-7.4,7.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 290.1,
    y1: 101.8,
    x2: 290.1,
    y2: 79
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 305.2,
    y1: 101.8,
    x2: 305.2,
    y2: 79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "291.5,80.7 296.8,80.7 296.8,96.1 291.5,96.1 291.5,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 291.5,
    y1: 88.4,
    x2: 296.8,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 291.5,
    y1: 84.6,
    x2: 296.8,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 291.5,
    y1: 91.8,
    x2: 296.8,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 294.2,
    y1: 80.7,
    x2: 294.2,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "298.5,80.7 303.8,80.7 303.8,96.1 298.5,96.1 298.5,80.7  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.5,
    y1: 88.4,
    x2: 303.8,
    y2: 88.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.5,
    y1: 84.6,
    x2: 303.8,
    y2: 84.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.5,
    y1: 91.8,
    x2: 303.8,
    y2: 91.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 301.1,
    y1: 80.7,
    x2: 301.1,
    y2: 96.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 296.8,
    y1: 96,
    x2: 296.8,
    y2: 101.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 298.5,
    y1: 96,
    x2: 298.5,
    y2: 101.8
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Dach",
    d: "M297.5,49.9c3.6,0.1,6.5,3,6.5,6.7h-13C290.9,52.9,293.8,50,297.5,49.9z M334.9,41.7h-8.6v2.2h-4.6v-2.2h-48.2 v2.2h-4.6v-2.2h-8.4l-45.8,22.8c0.2,0.9,0.8,1.7,1.2,2.2c0,0,163.5,0,163.5,0s0.6-0.8,0.9-1.4c0.3-0.6,0.3-0.9,0.3-0.9L334.9,41.7 z M330.3,50.9c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C329.8,51.1,330,50.9,330.3,50.9z M327.7,52.7 c0.2-0.3,0.8,0,1,0c0.2,0,0.8-0.3,0.9-0.4c0.2-0.1,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.7,0.4,1,0.4 c0.2,0,0.8-0.2,0.9,0c0.2,0.2-0.2,0.6-0.4,0.7c-0.2,0.1-0.5,0.3-0.6,0.5c-0.1,0.2-0.2,1.9-0.3,2.1c-0.1,0.2-0.8,0.5-1.2,0.5 c-0.4,0-1.1-0.3-1.2-0.5c-0.1-0.2-0.1-2-0.3-2.2c-0.2-0.2-0.5-0.3-0.7-0.5C327.9,53.4,327.5,53,327.7,52.7z M330.9,57.6 c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C330.6,56.9,330.9,57.2,330.9,57.6z M312.1,58.7 c0.5,0,13.2,0,13.7,0c0.5,0,0.7,0.3,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6c-0.4,0-13.2,0-13.7,0c-0.5,0-0.7-0.3-0.7-0.6 C311.4,58.9,311.6,58.7,312.1,58.7z M327.5,60.5v3.4h-17.3v-3.4H327.5z M306.3,58.7c0.4,0,3.4,0,3.8,0c0.4,0,0.6,0.3,0.6,0.6 c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-3.4,0-3.8,0c-0.4,0-0.6-0.3-0.6-0.6C305.7,59,305.9,58.7,306.3,58.7z M309.5,60.5v3.4h-2.4v-3.4 H309.5z M306.3,60.5v3.4h-8.6H289v-3.4h8.6H306.3z M290.8,58.7c0.5,0,13.2,0,13.7,0s0.7,0.3,0.7,0.6c0,0.4-0.3,0.6-0.7,0.6 c-0.4,0-13.2,0-13.7,0c-0.5,0-0.7-0.3-0.7-0.6C290.1,58.9,290.3,58.7,290.8,58.7z M285.1,58.7c0.4,0,3.4,0,3.8,0 c0.4,0,0.6,0.3,0.6,0.6c0,0.3-0.2,0.6-0.6,0.6c-0.4,0-3.4,0-3.8,0c-0.4,0-0.6-0.3-0.6-0.6C284.5,59,284.7,58.7,285.1,58.7z  M288.2,60.5v3.4h-2.4v-3.4H288.2z M285,60.5v3.4h-17.3v-3.4H285z M269.6,58.7c0.5,0,13.2,0,13.7,0c0.5,0,0.7,0.3,0.7,0.6 c0,0.4-0.3,0.6-0.7,0.6c-0.4,0-13.2,0-13.7,0c-0.5,0-0.7-0.3-0.7-0.6C268.8,58.9,269.1,58.7,269.6,58.7z M265.1,50.9 c0.2,0,0.4,0.2,0.4,0.4c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4C264.6,51.1,264.8,50.9,265.1,50.9z M262.5,52.7 c0.2-0.3,0.8,0,1,0c0.2,0,0.7-0.3,0.9-0.4c0.2-0.1,0.4-0.3,0.6-0.3c0.2,0,0.5,0.1,0.6,0.3c0.2,0.2,0.7,0.4,1,0.4 c0.2,0,0.8-0.2,0.9,0c0.2,0.2-0.2,0.6-0.4,0.7c-0.2,0.1-0.5,0.3-0.6,0.5c-0.1,0.2-0.2,1.9-0.3,2.1c-0.1,0.2-0.8,0.5-1.2,0.5 c-0.4,0-1.1-0.3-1.2-0.5c-0.1-0.2-0.1-2-0.3-2.2c-0.2-0.2-0.5-0.3-0.7-0.5C262.7,53.4,262.3,53,262.5,52.7z M265.7,57.6 c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C265.4,56.9,265.7,57.2,265.7,57.6z M262.6,58.7 c0.5,0,4.2,0,4.8,0c0.5,0,0.7,0.3,0.7,0.6c0,0.3-0.3,0.6-0.7,0.6c-0.5,0-4.3,0-4.8,0c-0.5,0-0.7-0.3-0.7-0.6 C261.9,59,262.1,58.7,262.6,58.7z M267,60.5v3.4h-3.8v-3.4H267z M267.4,65.7c-0.5,0-4.3,0-4.8,0c-0.5,0-0.7-0.3-0.7-0.6 s0.2-0.6,0.8-0.6s4.2,0,4.8,0c0.5,0,0.7,0.3,0.7,0.6C268.1,65.4,267.8,65.7,267.4,65.7z M283.2,65.7c-0.4,0-13.2,0-13.7,0 c-0.5,0-0.7-0.3-0.7-0.6c0-0.3,0.2-0.6,0.7-0.6c0.5,0,13.2,0,13.7,0c0.5,0,0.7,0.3,0.7,0.6C284,65.4,283.7,65.7,283.2,65.7z  M288.9,65.7c-0.4,0-3.4,0-3.8,0c-0.4,0-0.6-0.3-0.6-0.6s0.2-0.6,0.6-0.6c0.4,0,3.4,0,3.8,0c0.4,0,0.6,0.3,0.6,0.6 C289.4,65.4,289.2,65.7,288.9,65.7z M304.5,65.7c-0.4,0-13.2,0-13.7,0c-0.5,0-0.7-0.3-0.7-0.6c0-0.3,0.2-0.6,0.7-0.6 c0.5,0,13.2,0,13.7,0s0.7,0.3,0.7,0.6C305.2,65.4,304.9,65.7,304.5,65.7z M310.1,65.7c-0.4,0-3.4,0-3.8,0c-0.4,0-0.6-0.3-0.6-0.6 s0.2-0.6,0.6-0.6c0.4,0,3.4,0,3.8,0c0.4,0,0.6,0.3,0.6,0.6C310.7,65.4,310.5,65.7,310.1,65.7z M325.8,65.7c-0.4,0-13.2,0-13.7,0 c-0.5,0-0.7-0.3-0.7-0.6c0-0.3,0.2-0.6,0.7-0.6c0.5,0,13.2,0,13.7,0c0.5,0,0.7,0.3,0.7,0.6C326.5,65.4,326.2,65.7,325.8,65.7z  M332.6,65.6c-0.5,0-4.3,0-4.8,0c-0.5,0-0.7-0.3-0.7-0.6c0-0.3,0.2-0.6,0.8-0.6s4.2,0,4.8,0c0.5,0,0.7,0.3,0.7,0.6 C333.3,65.3,333,65.6,332.6,65.6z M328.3,63.9v-3.4h3.8v3.4H328.3z M332.6,59.9c-0.5,0-4.3,0-4.8,0c-0.5,0-0.7-0.3-0.7-0.6 c0-0.3,0.2-0.6,0.8-0.6s4.2,0,4.8,0c0.5,0,0.7,0.3,0.7,0.6C333.3,59.6,333,59.9,332.6,59.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dachfenster"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M303.1,55.9h-11c0-0.7,0.7-2.5,2-3.7l1.9,2.4c-0.4,0.5-0.7,1-0.7,1.3h4.3c0-0.3-0.2-0.8-0.6-1.3l1.9-2.4 C302.3,53.4,303.1,55.2,303.1,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.5,53.9v-3.1c1.4,0,2.6,0.6,3.4,1.4l-1.9,2.4C298.6,54.2,298.1,53.9,297.5,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.9,54.6l-1.9-2.4c0.9-0.8,2-1.4,3.4-1.4c0,0,0,0,0,0v3.1c0,0,0,0,0,0C296.8,53.9,296.3,54.2,295.9,54.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299,54.6L299,54.6L299,54.6c0.4,0.5,0.6,1,0.6,1.3h-4.3c0-0.3,0.2-0.8,0.7-1.3l0,0c0.4-0.4,0.9-0.7,1.5-0.7 c0,0,0,0,0,0v2v-2C298.1,53.9,298.6,54.2,299,54.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvLogoRgbOReg);
export default __webpack_public_path__ + "static/media/E&V_Logo_RGB_oReg.7afb8529.svg";
export { ForwardRef as ReactComponent };